import { createReducer } from 'redux-create-reducer';

import {
    UPLOAD_CSV_CLIENTS,
} from '../types/uploadCsvClientsTypes';

const initialState = {
    csvFile: [],
    isLoading: false,
};

const csvClientReducer = createReducer(initialState, {
    [UPLOAD_CSV_CLIENTS.DEFAULT]: (state, { payload }) => ({
        ...state,
        isLoading: true,
    }),
    [UPLOAD_CSV_CLIENTS.PENDING]: (state, { payload }) => ({
        ...state,
        isLoading: true,
    }),
    [UPLOAD_CSV_CLIENTS.REJECTED]: (state, { payload }) => ({
        ...state,
        isLoading: false,
    }),
    [UPLOAD_CSV_CLIENTS.FULFILLED]: (state, { payload }) => ({
        ...state,
        csvFile: payload.data,
        isLoading: false,
    }),
});


export default csvClientReducer;


// WEBPACK FOOTER //
// ./src/features/score-card/reducers/csvClientsReducer.js